// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--2-hg1";
export const copyright = "footer-module--copyright--3yIxz";